/**
 * Web session broadcast — uses BroadcastChannel to notify other tabs
 * when the session changes (login/logout).
 *
 * Supported in all modern browsers:
 * Chrome 54+, Firefox 38+, Safari 15.4+, Edge 79+
 */

const CHANNEL_NAME = 'cynosure_session';

interface SessionMessage {
  type: 'session-changed';
  userId: string | null;
}

let channel: BroadcastChannel | null = null;

function getChannel(): BroadcastChannel | null {
  if (typeof BroadcastChannel === 'undefined') return null;
  if (!channel) {
    channel = new BroadcastChannel(CHANNEL_NAME);
  }
  return channel;
}

export function broadcastSessionChange(userId: string | null): void {
  const ch = getChannel();
  if (!ch) return;
  const message: SessionMessage = { type: 'session-changed', userId };
  ch.postMessage(message);
}

export function onSessionChange(
  callback: (userId: string | null) => void,
): () => void {
  const ch = getChannel();
  if (!ch) return () => {};

  const handler = (event: MessageEvent<SessionMessage>) => {
    if (event.data?.type === 'session-changed') {
      callback(event.data.userId);
    }
  };

  ch.addEventListener('message', handler);
  return () => ch.removeEventListener('message', handler);
}
